import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from '../base';
import { WebsiteImportError } from '../../models';

// The web order import's open failures, and Dismiss for one that will never import.
@Injectable({
  providedIn: 'root',
})
export class WebsiteImportErrorService extends TmsWebBaseService {
  constructor() {
    super('WebsiteImportError');
  }

  search(): Observable<WebsiteImportError[]> {
    return this.httpService.post<WebsiteImportError[]>(`${this.apiUrl}/Search`, {});
  }

  dismiss(id: string): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Dismiss/${id}`, {});
  }
}
